/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_REBATE_PROGRAM_BALANCES = 'GET_REBATE_PROGRAM_BALANCES';
export const GET_REBATE_PROGRAM_NAME_BALANCES =
  'GET_REBATE_PROGRAM_NAME_BALANCES';
export const DISP_DETAIL_TOP_BAL_DATA = 'DISP_DETAIL_TOP_BAL_DATA';
export const GET_ERROR_MSG_TOP_BALANCES = 'GET_ERROR_MSG_TOP_BALANCES';
export const DISPLAY_QUARTER_RANGE = 'DISPLAY_QUARTER_RANGE';
export const DISPLAY_QUARTER_OBJ = 'DISPLAY_QUARTER_OBJ';
export const GET_CREDIT_DEBIT = 'GET_CREDIT_DEBIT';
export const DISPLAY_MANUFACTURE_NO = 'DISPLAY_MANUFACTURE_NO';
export const SET_MANUFACTURE_NO = 'SET_MANUFACTURE_NO';
export const GET_BALANCE_DUE = 'GET_BALANCE_DUE';
export const SET_CREDIT_DEBIT_OPTION = 'SET_CREDIT_DEBIT_OPTION';
export const GET_FROM_BALANCES = 'GET_FROM_BALANCES';
export const GET_TO_BALANCES = 'GET_TO_BALANCES';
export const SET_DISPLAY_OBJ_BALANCES = 'SET_DISPLAY_OBJ_BALANCES';
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE =
  'GET_DRAMS_INVOICE_START_QUARTER_VALUE';
export const GET_FIRST_SUMMARY_REPORT_OPTION =
  'GET_FIRST_SUMMARY_REPORT_OPTION';
export const GET_CURRENT_DISPLAY_OBJ_BALANCES =
  'GET_CURRENT_DISPLAY_OBJ_BALANCES';
export const GET_CURRENT_DISPLAY_DETAIL_OBJ_BALANCES =
  'GET_CURRENT_DISPLAY_DETAIL_OBJ_BALANCES';
export const SET_REFRESH_DATA_BALANCES = 'SET_REFRESH_DATA_BALANCES';
export const GET_PLAN_TYPE_DATA_BALANCES = 'GET_PLAN_TYPE_DATA_BALANCES';
export const GET_CREDIT_MFG_BALANCES = 'GET_CREDIT_MFG_BALANCES';
export const GET_DEBIT_MFG_BALANCES = 'GET_DEBIT_MFG_BALANCES';
export const GET_DATE_RANGE = 'GET_DATE_RANGE';
export const SET_REFRESH_DATA_BALANCES_DISPLAY =
  'SET_REFRESH_DATA_BALANCES_DISPLAY';
export const SET_EXPORT_ALL_TOP_BALANCES = 'SET_EXPORT_ALL_TOP_BALANCES';
export const SET_PAGINATION_INDEX_TO_BALANCE =
  'SET_PAGINATION_INDEX_TO_BALANCE';
